import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import { TextButton } from "../../../../Buttons/styled";

import { activeIds } from "../ImportingSummary";
import { SummaryTabsWrapper, TextButtonWrapper } from "./styled";

const SummaryTabs = ({ activeId, setActiveId, incorrectLength, correctLength }) => {
  return (
    <SummaryTabsWrapper width="100%">
      <TextButtonWrapper selected={activeId === activeIds.INCORRECT}>
        <TextButton onClick={() => setActiveId(activeIds.INCORRECT)}>
          {t(strCode.MISSING_DATA_BTN)} <span>{incorrectLength}</span>
        </TextButton>
      </TextButtonWrapper>

      <TextButtonWrapper selected={activeId === activeIds.CORRECT}>
        <TextButton onClick={() => setActiveId(activeIds.CORRECT)}>
          {t(strCode.READY_FOR_IMPORT_BTN)} <span>{correctLength}</span>
        </TextButton>
      </TextButtonWrapper>

      <span />
    </SummaryTabsWrapper>
  );
};

SummaryTabs.propTypes = {
  activeId: PropTypes.string.isRequired,
  setActiveId: PropTypes.func.isRequired,
  incorrectLength: PropTypes.number.isRequired,
  correctLength: PropTypes.number.isRequired
};

export default SummaryTabs;
